<template>
  <el-dialog title="Editar Contato Realizado" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="25%">
        <el-form size="small" label-position="top">
          <el-row :gutter="24">
            <el-col :span="14">
              <el-form-item class="form-item" label="Data de Retorno">
                <el-input v-model="data" v-mask="'##/##/####'"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item class="form-item" label="Hora">
                <el-input v-model="hora" v-mask="'##:##'"></el-input> 
              </el-form-item>          
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="fechar">Fechar</el-button>
          <el-button @click="gravar" type="primary">Confirmar</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    contato: Object,
    data: String,
    hora: String,
    visibility: Boolean
  },
  computed: {
    ...mapState('clientesStore', {
      cliente(state) { return state.clienteSelecionado }
    })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('clientesStore', [
      'usuariosDisponiveis',
      'atualizarContatoRealizado'
    ]),

    gravar(){
      this.contato.dataProximoContato = this.data + " " + this.hora;
      this.contato.cliente = { id: this.cliente.id };
      this.showLoading();

      this.atualizarContatoRealizado(this.contato).then((response) => {
        this.hideLoading();

        switch(response.status) {
          case "SUCESSO":
            this.console.log(response);
            this.contato = { id: 0 };
            this.$message.success(response.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(response.mensagem);
            break;
          case "ERRO":
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
      this.$emit('close');
    },
    fechar() {
      this.$emit('close');
    }    
  }
}
</script>
